// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const Money2Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Money2/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.167 2.917H5.833c-2.5 0-4.166 1.25-4.166 4.166v5.834c0 2.916 1.666 4.166 4.166 4.166h8.334c2.5 0 4.166-1.25 4.166-4.166V7.083c0-2.916-1.666-4.166-4.166-4.166ZM5.833 15.833c0-2.35-.758-3.216-2.916-3.316V7.483c2.158-.1 2.916-.966 2.916-3.316h8.334c0 2.35.758 3.216 2.916 3.316V12.517c-2.158.1-2.916.966-2.916 3.316H5.833Z"
}));
export default Money2Icon;